<template>
    <div>
        <div class="modal fade" id="mdetiquetasvolumepedido" tabindex="-1" role="dialog" aria-labelledby="mdestoqueproduto" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"><i class="fa fa-tags"></i> Etiquetas de volumes de pedido</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-12">
                                <label for="edfilial">Filial:</label>
                                <input type="text" class="form-control form-control-sm" id="edfilial" v-bind:value="pedido.idfilial+' - '+pedido.fantasia" disabled/>
                            </div>                            
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Nr. Pedido:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="pedido.id" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-8 col-lg-8">
                                <label for="edcliente">Cliente:</label>
                                <input type="text" class="form-control form-control-sm" id="edcliente" v-model="pedido.nomecliente" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edqtdvolumes">Volumes:</label>
                                <input type="number" class="form-control form-control-sm" id="edqtdvolumes" v-model="vqtdvolumes" min="1"/>
                            </div>                                                        
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="#" role="button" class="btn btn-success btn-sm" @click.prevent="mtdconfiremissao()" style="width:100px;"><i class="fa fa-check"></i> Confirmar</a>                        
                        <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal" style="width:100px;"><i class="fa fa-sign-out"></i> Cancelar</a>
                    </div>
                </div>
            </div>
        </div>                
    </div>
</template>
<script>
import util from '../utilitarios/util.js'
export default {
    name: 'cmpetiquetasvolumespedido',
    props:[
                'pedido'
          ],
    data: function() {
        return {
            vqtdvolumes         : 1,
            money				: {
                decimal         : ',',
                thousands       : '.',
                prefix          : '',//aqui colocar o cifrão se for necessário
                precision       : 2,
                masked          : false
            }            
        };
    },
    methods: {
        mtdformatavalordecimal(valor, digitos){
            return util.formatavalordecimais(valor, digitos);
        },
        mtdconfiremissao(){
            $("#mdetiquetasvolumepedido").modal('hide');
            window.open(this.$store.state.configpaths.pathcontrole+'rtimprimiretiquetasvolumespedido.php?idclientesac='+
                        this.$store.state.filialpadrao.idcliente+
                        '&idpedido='+this.pedido.id+'&qtdvolumes='+this.vqtdvolumes, '_blank');				
        }
    },
    mounted: function() {
        let vself = this;
        $("#mdetiquetasvolumepedido").on('shown.bs.modal', function(){
            vself.vqtdvolumes = 1;
            $('#edqtdvolumes').focus();
        });
        $("#mdetiquetasvolumepedido").on('hide.bs.modal', function(){
        });                        
    },    
    computed:{ 
    },
    watch: {
    }
}
</script>
<style>
    .lst-item-estoque{
        padding: 5px 15px !important;
        font-weight: 700;
        color: #666666;
    }
    .badge-item-estoque{
        font-size: 14px!important;
    }
    #mdestoqueproduto{
        z-index: 2001!important;
    }    
</style>